export function slugify(string) {
  return String(string).toLowerCase().split(" ").join("-").split("_").join("-");
}
